<svelte:options customElement={{ tag: "bt-add-question-set-button", shadow: "none", }} />

<script lang="ts">
  import { eventBus } from '$shared/lib/eventBus';

  export let curationId: number;
  export let addQuestionSetText: string = "Question set";

  let saving = false;

  // Creates an empty question set at the top of the curation and tells the list to show it.
  async function addQuestionSet() {
    if (saving) return;
    saving = true;

    try {
      const response = await fetch(`/curations/${curationId}/create_question_set`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (!response.ok) {
        alert('Failed to add question set. Please try again.');
        return;
      }

      const data = await response.json();
      eventBus.emit('question-set-added', data.curated_item);
    } catch (error) {
      console.error('Error adding question set:', error);
      alert('Failed to add question set. Please try again.');
    } finally {
      saving = false;
    }
  }
</script>

<button
  type="button"
  on:click={addQuestionSet}
  disabled={saving}
  class="font-normal text-base text-black hover:text-neutral-500"
>
  <p>{addQuestionSetText}</p>
</button>
